import React, { Component } from 'react';
import { connect } from 'react-redux';

import uuid from 'uuid';
import { toaster } from 'evergreen-ui';
import { bindActionCreators } from 'redux';
import * as needRefresh from '../../../../../actions/needRefresh';
import { UserChar } from '../../../../utilities/styledComponents/UserChar';
import Message from '../../../../Message';
import FileInput from '../../../../Briefing/FileInput';
import File from '../../../../File';
import { isMimeTypeImage } from '../../../../../services/briefing/file';

import { ContainerAnnotation, Button } from '../style';
import api from '../../../../../services/api';

class Annotation extends Component {
	state = {
		annotationContent: '',
		annotationFiles: [],
		messagesContent: [],
	};

	async componentDidMount() {
		const { demandId } = this.props;

		const response = await api.get(`/demands/${demandId}/annotations`);

		return this.setState({
			messagesContent: response.data,
		});
	}

	changeElement = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	};

	handleSaveAnnotation = () => {
		const { annotationContent, annotationFiles } = this.state;

		const { demandId } = this.props;

		const data = {
			text: annotationContent,
			files: annotationFiles,
		};

		api.post(`/demands/${demandId}/annotations`, data)
			.then((response) => {
				// eslint-disable-next-line react/destructuring-assignment
				this.props.needRefresh(true);
				toaster.success('Anotação inserida com sucesso!');

				return this.setState({
					messagesContent: response.data,
					annotationFiles: [],
				});
			})
			.catch(() => {
				toaster.danger('Ops! Você não escreveu nenhuma anotação.');
			})
			.finally(() => {
				this.setState({
					annotationContent: '',
				});
			});
	};

	handlerFile = (fieldName, value) => {
		this.setState({
			annotationFiles: value,
		});
	};

	render() {
		const { annotationContent, messagesContent, annotationFiles } = this.state;

		const { user } = this.props;

		return (
			<ContainerAnnotation>
				<h3 className="title title-checklist mb-3">Anotações:</h3>

				<div className="d-flex">
					<UserChar className="mr-2">
						{user.data ? (<span>{(user.data.attributes.name).charAt(0) || 'G'}</span>) : ''}
					</UserChar>

					<textarea
						placeholder="Escrever anotações"
						className="w-100"
						value={annotationContent}
						name="annotationContent"
						onChange={e => this.changeElement(e)}
					/>
				</div>
				<div className="row">
					<div className="col-9">
						<FileInput
							question=""
							required={false}
							clearField={!annotationFiles.length}
							nameField="annotation"
							classField="col-12"
							classContainer="annotation"
							meta={{ attention: 'annotation' }}
							onGetValueField={this.handlerFile}
						/>
					</div>

					<div className="col-3 align-self-start">
						<Button
							type="button"
							className="btn btn-secondary mt-3"
							onClick={this.handleSaveAnnotation}
						>
							Incluir anotações
						</Button>
					</div>
				</div>

				<div className="mt-4">
					{Object.keys(messagesContent).length > 0 ? (
						messagesContent.data.map(message => (
							<>
								<Message content={message.attributes} key={uuid.v4()} />
								{message.attributes.files
									? message.attributes.files.map(files => (
										<File
											url={files.url}
											name={files.name}
											isImage={isMimeTypeImage(files.mime_type)}
										/>
									)) : ''}
							</>
						))
					) : null}
				</div>
			</ContainerAnnotation>
		);
	}
}

const mapStateToProps = state => ({
	user: state.user,
});

const mapDispatchToProps = dispatch => bindActionCreators(needRefresh, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Annotation);
